import { clientApi } from 'shared/api/clientApi'

import type { KyrgyzstanCitiesResponse } from './model'

export const KyrgyzstanLocationsApi = {
  getCities(signal?: AbortSignal) {
    return clientApi.get<KyrgyzstanCitiesResponse>(
      '/kyrgyzstan/locations/cities',
      { signal },
    )
  },
}
